module.exports = __webpack_public_path__ + "static/media/eyeLookInRight.08f4042f.obj";